import Vue from 'vue';
import Vuex from 'vuex';
import HeatmapService from '../../services/HeatmapService';

Vue.use(Vuex);

export default {
    state: {
        showChart: false,
        showHeatmapChart: false,
        startDate: '',
        endDate: '',
    },
    mutations: {
        TOGGLE_CHART(state: any) {
            state.showChart = !state.showChart;
        },
        TOGGLE_HEATMAP_CHART(state: any) {
            state.showHeatmapChart = !state.showHeatmapChart;
        },
        SET_END_DATE(state: any, endDate: string) {
            state.endDate = endDate;
        },
        SET_START_DATE(state: any, startDate: string) {
            state.startDate = startDate;
        },
    },
    actions: {
        updateHeatmap(context: any, payload: any) {
            // UNUSED
            console.log('updateHeatmap aciton');
            console.log(payload);
            HeatmapService.getLockboxData(payload.startDate, payload.endDate)
            .then((response) => {
                console.log(response);
            });
        },
        toggleChart(context: any) {
            context.commit('TOGGLE_CHART');
        },
        toggleHeatmapChart(context: any) {
            context.commit('TOGGLE_HEATMAP_CHART');
        },
        updateEndDate(context: any, payload: string) {
            context.commit('SET_END_DATE', payload);
        },
        updateStartDate(context: any, payload: string) {
            context.commit('SET_START_DATE', payload);
        },
        initHeatmap(context: any) {
            // no state/mutations, this is only used to subscribe to actions in other components
        },
    },
};
